import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTriangleExclamation, FaArrowsRotate } from 'react-icons/fa6';

interface ErrorStateProps {
  connectionError: string;
}

/**
 * ErrorState sub-component
 * Shows error message when connection fails
 */
export const ErrorState: React.FC<ErrorStateProps> = memo(({ connectionError }) => {
  const { t } = useTranslation('training');

  return (
    <div className="rounded-xl border border-red-200/60 bg-card shadow-sm overflow-hidden text-center">
      <div className="px-6 py-8 sm:px-10 sm:py-12">
        <div className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br from-red-500 to-red-700 mb-5 sm:mb-6">
          <FaTriangleExclamation className="text-white text-base sm:text-lg" />
        </div>
        <h2 className="text-sm sm:text-base font-semibold text-red-700 mb-1.5 tracking-tight">
          {t('training.overlay.connectionError', { defaultValue: 'Verbindungsfehler' })}
        </h2>
        <p className="text-[11px] sm:text-xs text-muted-foreground leading-relaxed mb-5 sm:mb-6 max-w-sm mx-auto">
          {t('training.overlay.connectionErrorMessage', {
            defaultValue: 'Die Verbindung zum Server konnte nicht hergestellt werden. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
            error: connectionError
          })}
        </p>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 px-4 py-2 text-xs sm:text-sm font-medium text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 active:scale-[0.98] transition-all duration-150"
          onClick={() => window.location.reload()}
        >
          <FaArrowsRotate className="text-[10px]" />
          {t('training.overlay.cancel', { defaultValue: 'Abbrechen' })}
        </button>
      </div>
    </div>
  );
});

ErrorState.displayName = 'ErrorState';

export default ErrorState;
